<template>
    <div>


        <div class="author_tupianbb"></div>
        <img :src="author.faceimg" class="authorTopFaceimg">


        <div class="baisebackdl">
<!--            <el-button @click="sixin" class="pull-right" round type="warning" size="mini"  style="margin-left: 10px;">私信</el-button>-->
            <div class="authorTopUname">{{author.uname}}</div>
            <el-button class="pull-right" round type="warning" size="mini"  @click="attHandle">{{IattHe?'已关注':'关注'}}</el-button>
            
        </div>
        <div class="h20"></div>



        <img src="../../../assets/img/author_menu.png" @click="goauthormenu"  v-if="!webW"  class="gotop hander" style="bottom: 130px;">

    </div>


</template>
<script>
    import  PubSub from 'pubsub-js'

    import {atthe, getAuthorInfo, isatt} from '../../../api';
    import {dealResult, getWindowWidth} from "../../../api/common";


    export default {
        name: 'AuthorTop',
        components: {

        },

        data() {
            return {
                webW:true,
                IattHe:false,
                lander:{},
                authorId:'',
                author:{},
            };
        },
        methods: {
            goauthormenu(){
                this.$router.push('AuthorLeft?authorId='+this.authorId);
            },
            //是否关注了他
            isattFunc(){
                let o={ tuid:this.authorId ,uid:this.lander.uid,token:this.lander.token}
                isatt( o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.IattHe= true;
                    }else   if (res.data.status == 11) {
                        this.IattHe= false;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //作者信息
            getAuthorInfoFunc(){
                let o={ authorId:this.authorId ,uid:this.lander.uid,token:this.lander.token}
                getAuthorInfo( o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.author= res.data.obj;
                    } else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //关注按钮
            attHandle(){
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                let o={ tuid:this.authorId,uid:this.lander.uid,token:this.lander.token}
                atthe( o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.IattHe= true;
                        this.author.fansNum=res.data.obj;
                        PubSub.publish('changeAttFansData',true);
                    }else   if (res.data.status == 11) {
                        this.IattHe= false;
                        this.author.fansNum=res.data.obj;
                        PubSub.publish('changeAttFansData',true);
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
             sixin(){
                    this.$message.info('敬请期待')
            }
        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            this.lander = JSON.parse(this.$store.state.logininfo);
            if(this.$route.query.authorId!=undefined){
                this.authorId = this.$route.query.authorId;
                this.isattFunc();
                this.getAuthorInfoFunc()
            }




        }, watch:{
            $route:function(value){

                if(value.query.authorId!=undefined){
                    this.authorId=value.query.authorId;
                    this.isattFunc();
                    this.getAuthorInfoFunc()
                }


            }
        },
        activated() {




        },
        deactivated() {

        }


    };
</script>
<style scoped>
.authorTopFaceimg{margin-left: 50px;width: 100px;height: 100px;border-radius: 50%;box-shadow:5px 5px 5px rgba(0,0,0,0.5);position: absolute;z-index: 50;margin-top: 30px;}
.authorTopUname{margin-top:0px; margin-right:10px;margin-bottom:10px;text-align: right;color: #333333;}
.baisebackdl {
    background: #ffffff;
    padding: 60px 40px;
    font-size: 16px;
}
</style>

